import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    padding: ${props => (props.sidebar ? `0` : `12px 0`)};
`;

const Checkbox = styled.input`
    cursor: pointer;
    margin-bottom: 1.16em;
    margin-top: -0.3em;
    display: none;

    + label {
        cursor: pointer;
    }

    :checked + label::before {
        background: url('data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPkNoZWNrIEJveDwvdGl0bGU+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGw9IiNmZjI0NWUiIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIvPjxwYXRoIGQ9Ik0xNC42NDYgMTkuODZsLTMuNS0zLjQxOGMtLjE5NS0uMTg4LS4xOTUtLjQ5NCAwLS42ODRsLjcwNy0uNjgzYy4xOTUtLjE4OC41MTItLjE4OC43MDcgMEwxNSAxNy40NjdsNS40NC01LjMyNWMuMTk0LS4xODguNTEtLjE4OC43MDYgMGwuNzA3LjY4NGMuMTk1LjE4OC4xOTUuNDk1IDAgLjY4MmwtNi41IDYuMzVjLS4xOTUuMTktLjUxMi4xOS0uNzA3IDAiIGZpbGw9IiNGRkYiLz48L2c+PC9zdmc+');
    }

    + label::before {
        background: url('data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjx0aXRsZT5DaGVjazwvdGl0bGU+PGRlZnM+PGNpcmNsZSBpZD0iYSIgY3g9IjE2IiBjeT0iMTYiIHI9IjE2Ii8+PG1hc2sgaWQ9ImIiIHg9IjAiIHk9IjAiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48L2RlZnM+PHVzZSBtYXNrPSJ1cmwoI2IpIiB4bGluazpocmVmPSIjYSIgc3Ryb2tlLXdpZHRoPSI2IiBzdHJva2U9IiNFMEUwRTAiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==');
    }

    + label::before {
        content: '';
        width: 16px;
        height: 16px;
        margin-right: 0.75em;
        position: absolute;
        left: 0;
        top: 0;
    }
`;

const Label = styled.label`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 16px;
    letter-spacing: 1px;
    ${props => (props.uppercase ? 'text-transform: uppercase;' : '')}
    margin-bottom: 0.5em;
    padding-left: 22px;
    position: relative;

    .text {
        line-height: 12px;
        display: inline-block;
    }
`;

const CheckboxGroup = props => (
    <Container sidebar={props.sidebar} style={props.style}>
        <Checkbox
            onClick={props.onClick || null}
            id={props.input.name}
            {...props.input}
            type="checkbox"
            checked={props.input.value}
        />
        <Label htmlFor={props.input.name} uppercase={!props.keepExistingCapitalization}>
            <span className="text">
                {props.label}
                {props.link}
            </span>
        </Label>
    </Container>
);

CheckboxGroup.propTypes = {
    label: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    keepExistingCapitalization: PropTypes.bool,
    link: PropTypes.element,
    onClick: PropTypes.func,
    primary: PropTypes.bool,
    sidebar: PropTypes.bool,
    style: PropTypes.string
};

export default CheckboxGroup;
